import { useSelector } from 'react-redux';
import {
    selectAllOpenPRsAgainstWorkingBranch,
    selectAllOpenPRsAgainstReleaseBranch,
    selectAllTicketOnlyItems,
} from '../../selectors/selectors';
import { selectCommitsOnlyOnWorkingBranch } from '../../selectors/memoizedSelectors';
import { RootState } from '../../reducers/reducers';

export const useCanAddFixRequestForFeatureItem: (featureItemId: string, stepRunId: string) => boolean = (
    featureItemId,
    stepRunId,
) => {
    const openPRsAgainstWorkingBranch = useSelector((state: RootState) =>
        selectAllOpenPRsAgainstWorkingBranch(state, stepRunId),
    );

    const commitsOnlyOnWorkingBranch = useSelector((state: RootState) =>
        selectCommitsOnlyOnWorkingBranch(state, stepRunId),
    );

    const openPRsAgainstReleaseBranch = useSelector((state: RootState) =>
        selectAllOpenPRsAgainstReleaseBranch(state, stepRunId),
    );

    const ticketOnlyItems = useSelector((state: RootState) => selectAllTicketOnlyItems(state, stepRunId));

    return (
        openPRsAgainstWorkingBranch.some((featureItem) => featureItem.id === featureItemId) ||
        commitsOnlyOnWorkingBranch.some((featureItem) => featureItem.id === featureItemId) ||
        openPRsAgainstReleaseBranch.some((featureItem) => featureItem.id === featureItemId) ||
        ticketOnlyItems.some((featureItem) => featureItem.id === featureItemId)
    );
};

export default useCanAddFixRequestForFeatureItem;
